/* ------------------------------------------------------------------
Draggable Notes:
    -  nodeRef is mandatory on react-draggable 4.x, ignorable with React 18 but
      will blast with React 19, so adding it now

    - Draggable now forces that we use every single of its props even if not needed
      SilencedDraggable simply tells it to shut up
------------------------------------------------------------------ */

import { PaperProps, Paper } from "@mui/material";
import { useRef } from "react";
import Draggable, { DraggableProps } from "react-draggable";

const SilencedDraggable = Draggable as React.ComponentClass<Partial<DraggableProps>>;

export default function DraggablePaper(props: PaperProps) {
  const nodeRef = useRef<HTMLDivElement>(null);
  return (
    <SilencedDraggable
      nodeRef={nodeRef as React.RefObject<HTMLDivElement>}
      handle={'#overwatch-modal-drag-handle'}
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper ref={nodeRef} {...props} />
    </SilencedDraggable>
  );
}
